import { defineMessages } from 'react-intl';

import channelTypes from '../shared/constants/channel-types';
import { videoTypes } from '../shared/constants/video-types';
import { contentRatings } from '../shared/constants/content-ratings';
import channelFeedTypes from '../shared/constants/channel-feed-types';
import { previewTypes } from '@wix/wix-vod-shared/src/common/constants/preview-types';
import videoSources from '@wix/wix-vod-shared/src/common/constants/video-sources';
import { genres } from '@wix/wix-vod-shared/src/common/constants/genres';
import { categories as categoryKeys, roles } from '@wix/wix-vod-shared/src/common/constants/crew';

export default defineMessages({
  videoInfoFullText: {
    id: 'widget.action-button-labels.video-info-full',
    defaultMessage: 'Video Info',
  },
  videoInfoShortText: {
    id: 'widget.action-button-labels.video-info-short',
    defaultMessage: 'Info',
  },
  shareVideoFullText: {
    id: 'widget.action-button-labels.share-video-full',
    defaultMessage: 'Share Video',
  },
  shareVideoShortText: {
    id: 'widget.action-button-labels.share-video-short',
    defaultMessage: 'Share',
  },
  showAllCardsFullText: {
    id: 'widget.action-button-labels.show-all-cards-full',
    defaultMessage: 'Related Links',
  },
  showAllCardsShortText: {
    id: 'widget.action-button-labels.show-all-cards-short',
    defaultMessage: 'Related Links',
  },
  getSubscriptionSmall: {
    id: 'widget.overlay-buttons.get-subscription-small',
    defaultMessage: 'Subscribe',
  },
  watchPreview: {
    id: 'widget.overlay-buttons.watch-preview',
    defaultMessage: 'Watch Preview',
  },
  watchTrailer: {
    id: 'widget.overlay-buttons.watch-trailer',
    defaultMessage: 'Watch Trailer',
  },
  startWatching: {
    id: 'widget.overlay-buttons.start-watching',
    defaultMessage: 'Watch Now',
  },
  playVideo: {
    id: 'widget.overlay-buttons.play-video',
    defaultMessage: 'Play Video',
  },
  watchLive: {
    id: 'widget.overlay-buttons.watch-live',
    defaultMessage: 'Watch Live',
  },
  nextVideo: {
    id: 'widget.overlay-buttons.next-video',
    defaultMessage: 'Next Video',
  },
  trailer: {
    id: 'widget.overlay-buttons.trailer',
    defaultMessage: 'Trailer',
  },
  allVideos: {
    id: 'widget.overlay-buttons.all-videos',
    defaultMessage: 'All videos',
  },
  continueWatching: {
    id: 'widget.overlay-buttons.continue-watching',
    defaultMessage: 'Resume Video',
  },
  comingSoon: {
    id: 'widget.overlay-buttons.coming-soon',
    defaultMessage: 'Coming Soon',
  },
  next: {
    id: 'shared.navigation.next-page',
    defaultMessage: 'Next',
  },
  prev: {
    id: 'shared.navigation.previous-page',
    defaultMessage: 'Prev',
  },
  AUD: {
    id: 'shared.currency.aud',
    defaultMessage: 'Australian Dollar',
  },
  BRL: {
    id: 'shared.currency.brl',
    defaultMessage: 'Brazilian Real',
  },
  CAD: {
    id: 'shared.currency.cad',
    defaultMessage: 'Canadian Dollar',
  },
  CHF: {
    id: 'shared.currency.chf',
    defaultMessage: 'Swiss Franc',
  },
  CZK: {
    id: 'shared.currency.czk',
    defaultMessage: 'Czech Republic Koruna',
  },
  DKK: {
    id: 'shared.currency.dkk',
    defaultMessage: 'Danish Krone',
  },
  EUR: {
    id: 'shared.currency.eur',
    defaultMessage: 'Euro',
  },
  GBP: {
    id: 'shared.currency.gbp',
    defaultMessage: 'British Pound',
  },
  HKD: {
    id: 'shared.currency.hkd',
    defaultMessage: 'Hong Kong Dollar',
  },
  HUF: {
    id: 'shared.currency.huf',
    defaultMessage: 'Hungarian Forint',
  },
  ILS: {
    id: 'shared.currency.ils',
    defaultMessage: 'New Israeli Shekels',
  },
  JPY: {
    id: 'shared.currency.jpy',
    defaultMessage: 'Japanese Yen',
  },
  MXN: {
    id: 'shared.currency.mxn',
    defaultMessage: 'Mexican Peso',
  },
  MYR: {
    id: 'shared.currency.myr',
    defaultMessage: 'Malaysian Ringgit',
  },
  NOK: {
    id: 'shared.currency.nok',
    defaultMessage: 'Norwegian Krone',
  },
  NZD: {
    id: 'shared.currency.nzd',
    defaultMessage: 'New Zealand Dollar',
  },
  PHP: {
    id: 'shared.currency.php',
    defaultMessage: 'Philippine Peso',
  },
  PLN: {
    id: 'shared.currency.pln',
    defaultMessage: 'Polish Zloty',
  },
  RUB: {
    id: 'shared.currency.rub',
    defaultMessage: 'Russian Ruble',
  },
  SEK: {
    id: 'shared.currency.sek',
    defaultMessage: 'Swedish Krona',
  },
  SGD: {
    id: 'shared.currency.sgd',
    defaultMessage: 'Singapore Dollar',
  },
  THB: {
    id: 'shared.currency.thb',
    defaultMessage: 'Thai Baht',
  },
  TWD: {
    id: 'shared.currency.twd',
    defaultMessage: 'Taiwan New Dollar',
  },
  USD: {
    id: 'shared.currency.usd',
    defaultMessage: 'United States Dollar',
  },
  BIF: {
    id: 'shared.currency.bif',
    defaultMessage: 'Burundi Franc',
  },
  CVE: {
    id: 'shared.currency.cve',
    defaultMessage: 'Cape Verde Escudo',
  },
  KMF: {
    id: 'shared.currency.kmf',
    defaultMessage: 'Comoro Franc',
  },
  CDF: {
    id: 'shared.currency.cdf',
    defaultMessage: 'Franc Congolais',
  },
  DJF: {
    id: 'shared.currency.djf',
    defaultMessage: 'Djibouti Franc',
  },
  ERN: {
    id: 'shared.currency.ern',
    defaultMessage: 'Nakfa',
  },
  GNF: {
    id: 'shared.currency.gnf',
    defaultMessage: 'Guinea Franc',
  },
  LSL: {
    id: 'shared.currency.lsl',
    defaultMessage: 'Loti',
  },
  LYD: {
    id: 'shared.currency.lyd',
    defaultMessage: 'Libyan dinar',
  },
  MWK: {
    id: 'shared.currency.mwk',
    defaultMessage: 'Kwacha',
  },
  MRO: {
    id: 'shared.currency.mro',
    defaultMessage: 'Ouguiya',
  },
  SLL: {
    id: 'shared.currency.sll',
    defaultMessage: 'Leone',
  },
  SZL: {
    id: 'shared.currency.szl',
    defaultMessage: 'Lilangeni',
  },
  TJS: {
    id: 'shared.currency.tjs',
    defaultMessage: 'Somoni',
  },
  TOP: {
    id: 'shared.currency.top',
    defaultMessage: 'Pa\'anga',
  },
  XPF: {
    id: 'shared.currency.xpf',
    defaultMessage: 'CFP Franc',
  },
  XOF: {
    id: 'shared.currency.xof',
    defaultMessage: 'CFA Franc BCEAO',
  },
  XAF: {
    id: 'shared.currency.xaf',
    defaultMessage: 'CFA Franc BEAC',
  },
  WST: {
    id: 'shared.currency.wst',
    defaultMessage: 'Tala',
  },
  VUV: {
    id: 'shared.currency.vuv',
    defaultMessage: 'Vatu',
  },
  UGX: {
    id: 'shared.currency.ugx',
    defaultMessage: 'Uganda Shilling',
  },
  TZS: {
    id: 'shared.currency.tzs',
    defaultMessage: 'Tanzanian Shilling',
  },
  STD: {
    id: 'shared.currency.std',
    defaultMessage: 'Dobra',
  },
  RWF: {
    id: 'shared.currency.rwf',
    defaultMessage: 'Rwanda Franc',
  },
  PGK: {
    id: 'shared.currency.pgk',
    defaultMessage: 'Kina',
  },
  MVR: {
    id: 'shared.currency.mvr',
    defaultMessage: 'Rufiyaa',
  },
  MOP: {
    id: 'shared.currency.mop',
    defaultMessage: 'Pataca',
  },
  MMK: {
    id: 'shared.currency.mmk',
    defaultMessage: 'Kyat',
  },
  MDL: {
    id: 'shared.currency.mdl',
    defaultMessage: 'Moldovan Leu',
  },
  HTG: {
    id: 'shared.currency.htg',
    defaultMessage: 'Gourde',
  },
  GMD: {
    id: 'shared.currency.gmd',
    defaultMessage: 'Dalasi',
  },
  GEL: {
    id: 'shared.currency.gel',
    defaultMessage: 'Lari',
  },
  ETB: {
    id: 'shared.currency.etb',
    defaultMessage: 'Ethiopian Birr',
  },
  BTN: {
    id: 'shared.currency.btn',
    defaultMessage: 'Ngultrum',
  },
  BDT: {
    id: 'shared.currency.bdt',
    defaultMessage: 'Taka',
  },
  AOA: {
    id: 'shared.currency.aoa',
    defaultMessage: 'Kwanza',
  },
  AED: {
    id: 'shared.currency.aed',
    defaultMessage: 'UAE Dirham',
  },
  MGA: {
    id: 'shared.currency.mga',
    defaultMessage: 'Malagasy Ariary',
  },
  GHS: {
    id: 'shared.currency.ghs',
    defaultMessage: 'Ghanaian Cedi',
  },
  TMT: {
    id: 'shared.currency.tmt',
    defaultMessage: 'Turkmenistani Manat',
  },
  DZD: {
    id: 'shared.currency.dzd',
    defaultMessage: 'Algerian Dinar',
  },
  MAD: {
    id: 'shared.currency.mad',
    defaultMessage: 'Moroccan Dirham',
  },
  KWD: {
    id: 'shared.currency.kwd',
    defaultMessage: 'Kuwaiti Dinar',
  },
  TND: {
    id: 'shared.currency.tnd',
    defaultMessage: 'Tunisian Dinar',
  },
  AZN: {
    id: 'shared.currency.azn',
    defaultMessage: 'Azerbaijan Manat',
  },
  BGN: {
    id: 'shared.currency.bgl',
    defaultMessage: 'Bulgarian Lev',
  },
  UZS: {
    id: 'shared.currency.uzs',
    defaultMessage: 'Uzbekistan Sum',
  },
  KZT: {
    id: 'shared.currency.kzt',
    defaultMessage: 'Tenge',
  },
  KGS: {
    id: 'shared.currency.kgs',
    defaultMessage: 'Som',
  },
  RSD: {
    id: 'shared.currency.rsd',
    defaultMessage: 'Serbian Dinar',
  },
  MKD: {
    id: 'shared.currency.mkd',
    defaultMessage: 'Macedonian Denar',
  },
  TTD: {
    id: 'shared.currency.ttd',
    defaultMessage: 'Trinidad and Tobago Dollar',
  },
  PEN: {
    id: 'shared.currency.pen',
    defaultMessage: 'Nuevo Sol',
  },
  SOS: {
    id: 'shared.currency.sos',
    defaultMessage: 'Somali Shilling',
  },
  IDR: {
    id: 'shared.currency.idr',
    defaultMessage: 'Rupiah',
  },
  DOP: {
    id: 'shared.currency.dop',
    defaultMessage: 'Dominican Peso',
  },
  ZAR: {
    id: 'shared.currency.zar',
    defaultMessage: 'Rand',
  },
  GTQ: {
    id: 'shared.currency.gtq',
    defaultMessage: 'Quetzal',
  },
  BYN: {
    id: 'shared.currency.byn',
    defaultMessage: 'Belarussian Ruble',
  },
  BWP: {
    id: 'shared.currency.bwp',
    defaultMessage: 'Pula',
  },
  MZN: {
    id: 'shared.currency.mzn',
    defaultMessage: 'Mozambican Metical',
  },
  ALL: {
    id: 'shared.currency.all',
    defaultMessage: 'Lek',
  },
  RON: {
    id: 'shared.currency.ron',
    defaultMessage: 'Romanian Lei',
  },
  HNL: {
    id: 'shared.currency.hnl',
    defaultMessage: 'Lempira',
  },
  KES: {
    id: 'shared.currency.kes',
    defaultMessage: 'Kenyan Shilling',
  },
  ISK: {
    id: 'shared.currency.isk',
    defaultMessage: 'Iceland Krona',
  },
  HRK: {
    id: 'shared.currency.hrk',
    defaultMessage: 'Croatian Kuna',
  },
  BAM: {
    id: 'shared.currency.bam',
    defaultMessage: 'Convertible Mark',
  },
  JOD: {
    id: 'shared.currency.jod',
    defaultMessage: 'Jordanian Dinar',
  },
  JMD: {
    id: 'shared.currency.jmd',
    defaultMessage: 'Jamaican Dollar',
  },
  PYG: {
    id: 'shared.currency.pyg',
    defaultMessage: 'Guarani',
  },
  AWG: {
    id: 'shared.currency.awg',
    defaultMessage: 'Aruban Guilder',
  },
  ANG: {
    id: 'shared.currency.ang',
    defaultMessage: 'Netherlands Antillan Guilder',
  },
  NIO: {
    id: 'shared.currency.nio',
    defaultMessage: 'Cordoba Oro',
  },
  BZD: {
    id: 'shared.currency.bzd',
    defaultMessage: 'Belize Dollar',
  },
  VEF: {
    id: 'shared.currency.vef',
    defaultMessage: 'Bolívar fuerte venezolano',
  },
  PAB: {
    id: 'shared.currency.pab',
    defaultMessage: 'Balboa',
  },
  YER: {
    id: 'shared.currency.yer',
    defaultMessage: 'Yemeni Rial',
  },
  SAR: {
    id: 'shared.currency.sar',
    defaultMessage: 'Saudi Riyal',
  },
  QAR: {
    id: 'shared.currency.qar',
    defaultMessage: 'Qatari Rial',
  },
  OMR: {
    id: 'shared.currency.omr',
    defaultMessage: 'Rial Omani',
  },
  SCR: {
    id: 'shared.currency.scr',
    defaultMessage: 'Seychelles Rupee',
  },
  PKR: {
    id: 'shared.currency.pkr',
    defaultMessage: 'Pakistan Rupee',
  },
  NPR: {
    id: 'shared.currency.npr',
    defaultMessage: 'Nepalese Rupee',
  },
  MUR: {
    id: 'shared.currency.mur',
    defaultMessage: 'Mauritius Rupee',
  },
  LKR: {
    id: 'shared.currency.lkr',
    defaultMessage: 'Sri Lanka Rupee',
  },
  UAH: {
    id: 'shared.currency.uah',
    defaultMessage: 'Hryvnia',
  },
  MNT: {
    id: 'shared.currency.mnt',
    defaultMessage: 'Tugrik (Tugrug)',
  },
  LAK: {
    id: 'shared.currency.lak',
    defaultMessage: 'Kip',
  },
  VND: {
    id: 'shared.currency.vnd',
    defaultMessage: 'Dong',
  },
  KRW: {
    id: 'shared.currency.krw',
    defaultMessage: 'Korean Won',
  },
  NGN: {
    id: 'shared.currency.ngn',
    defaultMessage: 'Naira',
  },
  CRC: {
    id: 'shared.currency.crc',
    defaultMessage: 'Costa Rican Colon',
  },
  KHR: {
    id: 'shared.currency.khr',
    defaultMessage: 'Riel',
  },
  AFN: {
    id: 'shared.currency.afn',
    defaultMessage: 'Afghan Afghani',
  },
  CNY: {
    id: 'shared.currency.cny',
    defaultMessage: 'Yuan Renminbi',
  },
  FKP: {
    id: 'shared.currency.fkp',
    defaultMessage: 'Falkland Islands Pound',
  },
  SHP: {
    id: 'shared.currency.shp',
    defaultMessage: 'Saint Helena Pound',
  },
  GIP: {
    id: 'shared.currency.gip',
    defaultMessage: 'Gibraltar Pound',
  },
  LBP: {
    id: 'shared.currency.lbp',
    defaultMessage: 'Lebanese Pound',
  },
  EGP: {
    id: 'shared.currency.egp',
    defaultMessage: 'Egyptian Pound',
  },
  UYU: {
    id: 'shared.currency.uyu',
    defaultMessage: 'Peso Uruguayo',
  },
  BOB: {
    id: 'shared.currency.bob',
    defaultMessage: 'Boliviano',
  },
  BMD: {
    id: 'shared.currency.bmd',
    defaultMessage: 'Bermudian Dollar',
  },
  SBD: {
    id: 'shared.currency.sbd',
    defaultMessage: 'Solomon Islands Dollar',
  },
  XCD: {
    id: 'shared.currency.xcd',
    defaultMessage: 'East Carribbean Dollar',
  },
  LRD: {
    id: 'shared.currency.lrd',
    defaultMessage: 'Liberian Dollar',
  },
  KYD: {
    id: 'shared.currency.kyd',
    defaultMessage: 'Cayman Islands Dollar',
  },
  GYD: {
    id: 'shared.currency.gyd',
    defaultMessage: 'Guyana Dollar',
  },
  FJD: {
    id: 'shared.currency.fjd',
    defaultMessage: 'Fiji Dollar',
  },
  COP: {
    id: 'shared.currency.cop',
    defaultMessage: 'Colombian Peso',
  },
  CLP: {
    id: 'shared.currency.clp',
    defaultMessage: 'Chilean Peso',
  },
  BSD: {
    id: 'shared.currency.bsd',
    defaultMessage: 'Bahamian Dollar',
  },
  BND: {
    id: 'shared.currency.bnd',
    defaultMessage: 'Brunei Dollar',
  },
  BBD: {
    id: 'shared.currency.bbd',
    defaultMessage: 'Barbados Dollar',
  },
  ARS: {
    id: 'shared.currency.ars',
    defaultMessage: 'Argentine Peso',
  },
  NAD: {
    id: 'shared.currency.nad',
    defaultMessage: 'Namibian Dollar',
  },
  SRD: {
    id: 'shared.currency.srd',
    defaultMessage: 'Surinamese Dollar',
  },
  BHD: {
    id: 'shared.currency.bhd',
    defaultMessage: 'Bahraini Dinar',
  },
  AMD: {
    id: 'shared.currency.amd',
    defaultMessage: 'Armenian Dram',
  },
  TRY: {
    id: 'shared.currency.try',
    defaultMessage: 'Yeni Türk Liras (YTL)',
  },
  INR: {
    id: 'shared.currency.inr',
    defaultMessage: 'Indian Rupee',
  },
  IQD: {
    id: 'shared.currency.iqd',
    defaultMessage: 'Iraqi Dinar',
  },
  ZMW: {
    id: 'shared.currency.zmw',
    defaultMessage: 'Zambian Kwacha',
  },
  wixVideo: {
    id: 'shared.wix-video',
    defaultMessage: 'Wix Video',
  },
  channels: {
    id: 'shared.channels',
    defaultMessage: 'Channels',
  },
  channelInfo: {
    id: 'shared.channel-info',
    defaultMessage: 'Channel info',
  },
  videoLibrary: {
    id: 'shared.video-library',
    defaultMessage: 'Video Library',
  },
  emailMarketing: {
    id: 'shared.email-marketing',
    defaultMessage: 'Email Marketing',
  },
  insights: {
    id: 'shared.insights',
    defaultMessage: 'Insights',
  },
  stats: {
    id: 'shared.stats',
    defaultMessage: 'Insights',
  },
  overview: {
    id: 'shared.overview',
    defaultMessage: 'Overview',
  },
  video: {
    id: 'shared.video',
    defaultMessage: 'Video',
  },
  siteTraffic: {
    id: 'shared.site-traffic',
    defaultMessage: 'Site Traffic',
  },
  videos: {
    id: 'shared.videos',
    defaultMessage: 'Videos',
  },
  settings: {
    id: 'shared.settings',
    defaultMessage: 'Settings',
  },
  preview: {
    id: 'shared.preview',
    defaultMessage: 'Preview',
  },
  previewSite: {
    id: 'shared.preview-site',
    defaultMessage: 'Preview Site',
  },
  upgrade: {
    id: 'shared.upgrade',
    defaultMessage: 'Upgrade',
  },
  upgradeNow: {
    id: 'shared.upgrade-now',
    defaultMessage: 'Upgrade Now',
  },
  help: {
    id: 'shared.help',
    defaultMessage: 'Help',
  },
  feedback: {
    id: 'shared.feedback',
    defaultMessage: 'Feedback',
  },
  helpAndFeedback: {
    id: 'shared.help-and-feedback',
    defaultMessage: 'Help and Feedback',
  },
  free: {
    id: 'shared.free',
    defaultMessage: 'Free',
  },
  memberOnly: {
    id: 'shared.member-only',
    defaultMessage: 'Free with sign up',
  },
  sale: {
    id: 'shared.sale',
    defaultMessage: 'Buy',
  },
  saleWithPrice: {
    id: 'shared.sale-with-price',
    defaultMessage: '{price} Buy',
  },
  rent: {
    id: 'shared.rent',
    defaultMessage: 'Rent',
  },
  rentWithPrice: {
    id: 'shared.rent-with-price',
    defaultMessage: '{price} Rent',
  },
  subscriptionWithPrice: {
    id: 'shared.subscription-with-price',
    defaultMessage: '{price} Monthly subscription',
  },
  no: {
    id: 'shared.no',
    defaultMessage: 'No',
  },
  yes: {
    id: 'shared.yes',
    defaultMessage: 'Yes',
  },
  cancel: {
    id: 'shared.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'shared.continue',
    defaultMessage: 'Continue',
  },
  save: {
    id: 'shared.save',
    defaultMessage: 'Save',
  },
  delete: {
    id: 'shared.delete',
    defaultMessage: 'Delete',
  },
  change: {
    id: 'shared.change',
    defaultMessage: 'Change',
  },
  remove: {
    id: 'shared.remove',
    defaultMessage: 'Remove',
  },
  edit: {
    id: 'shared.edit',
    defaultMessage: 'Edit',
  },
  videosCount: {
    id: 'shared.videosCount',
    defaultMessage: '{videosCount, plural, =0 {No videos} =1 {1 Video} other {# Videos}}',
  },
  noVideos: {
    id: 'shared.noVideos',
    defaultMessage: 'No Videos',
  },
  oneVideo: {
    id: 'shared.oneVideo',
    defaultMessage: '1 Video',
  },
  nVideos: {
    id: 'shared.nVideos',
    defaultMessage: '{videosCount} Videos',
  },
  moviesCount: {
    id: 'shared.movies-count',
    defaultMessage: '{moviesCount, plural, =0 {No movies} =1 {1 Movie} other {# Movies}}',
  },
  subscription: {
    id: 'shared.subscription',
    defaultMessage: 'Subscription',
  },
  price: {
    id: 'shared.price',
    defaultMessage: 'Price',
  },
  period: {
    id: 'shared.period',
    defaultMessage: 'Available for',
  },
  new: {
    id: 'shared.new',
    defaultMessage: 'New',
  },
  uploading: {
    id: 'shared.uploading',
    defaultMessage: 'Uploading...',
  },
  featuredVideo: {
    id: 'shared.featured-video',
    defaultMessage: 'Featured video',
  },
  required: {
    id: 'shared.required',
    defaultMessage: 'Required',
  },
  search: {
    id: 'shared.search',
    defaultMessage: 'Search',
  },
  duplicate: {
    id: 'shared.duplicate',
    defaultMessage: 'Duplicate',
  },
  purchased: {
    id: 'actions.purchased',
    defaultMessage: 'You own this video',
  },
  rented: {
    id: 'actions.rented',
    defaultMessage: 'Rented until {date}',
  },
  [channelTypes.CHANNEL]: {
    id: 'shared.channel-types.channel',
    defaultMessage: 'Channel',
  },
  [channelTypes.YOUTUBE_FEED]: {
    id: 'shared.channel-types.youtube-feed',
    defaultMessage: 'YouTube Feed',
  },
  [videoTypes.MOVIE_THEATRICAL]: {
    id: 'shared.video-types.movie-theatrical',
    defaultMessage: 'Movie (Theatrical)',
  },
  [videoTypes.TELEVISION]: {
    id: 'shared.video-types.television',
    defaultMessage: 'Television',
  },
  [videoTypes.MADE_FOR_VIDEO]: {
    id: 'shared.video-types.made-for-video',
    defaultMessage: 'Made for Video',
  },
  [videoTypes.VIDEO_COURSE]: {
    id: 'shared.video-types.video-course',
    defaultMessage: 'Video Course',
  },
  [videoTypes.PORTFOLIO]: {
    id: 'shared.video-types.portfolio',
    defaultMessage: 'Portfolio / Show Reel',
  },
  [videoTypes.PERSONAL]: {
    id: 'shared.video-types.personal',
    defaultMessage: 'Personal',
  },
  [videoTypes.FILM]: {
    id: 'shared.video-types.film',
    defaultMessage: 'Film',
  },
  [videoTypes.VLOG]: {
    id: 'shared.video-types.vlog',
    defaultMessage: 'Vlog',
  },
  [videoTypes.WEB_SERIES]: {
    id: 'shared.video-types.web-series',
    defaultMessage: 'Web Series',
  },
  [videoTypes.PRODUCT_DEMO]: {
    id: 'shared.video-types.product-demo',
    defaultMessage: 'Product Demo',
  },
  [videoTypes.TESTIMONIALS]: {
    id: 'shared.video-types.testimonials',
    defaultMessage: 'Testimonials',
  },
  [videoTypes.TUTORIALS]: {
    id: 'shared.video-types.tutorials',
    defaultMessage: 'Tutorials & How to\'s',
  },
  [videoTypes.EDUCATION]: {
    id: 'shared.video-types.education',
    defaultMessage: 'Education',
  },
  [videoTypes.MUSIC]: {
    id: 'shared.video-types.music',
    defaultMessage: 'Music',
  },
  [videoTypes.OTHER]: {
    id: 'shared.video-types.other',
    defaultMessage: 'Other',
  },
  [contentRatings.ALL]: {
    id: 'shared.content-ratings.all',
    defaultMessage: 'All audiences',
  },
  [contentRatings.MATURE]: {
    id: 'shared.content-ratings.mature',
    defaultMessage: 'Mature content',
  },
  [`${channelTypes.YOUTUBE_FEED}.${channelFeedTypes.CHANNEL}`]: {
    id: 'shared.channel-feed-types.youtube-feed.channel',
    defaultMessage: 'channel',
  },
  [`${channelTypes.YOUTUBE_FEED}.${channelFeedTypes.PLAYLIST}`]: {
    id: 'shared.channel-feed-types.youtube-feed.playlist',
    defaultMessage: 'playlist',
  },
  [previewTypes.FIRST_20_SEC]: {
    id: 'shared.trailer-types.first-20-sec',
    defaultMessage: 'Show first 20 sec of video',
  },
  [previewTypes.TRAILER]: {
    id: 'shared.trailer-types.trailer',
    defaultMessage: 'Upload a trailer',
  },
  [previewTypes.URL]: {
    id: 'shared.trailer-types.url',
    defaultMessage: 'Add trailer URL',
  },
  [previewTypes.NONE]: {
    id: 'shared.trailer-types.none',
    defaultMessage: 'Don’t show',
  },
  [videoSources.COMPUTER]: {
    id: 'shared.video-sources.computer',
    defaultMessage: 'Computer',
  },
  [videoSources.DROPBOX]: {
    id: 'shared.video-sources.dropbox',
    defaultMessage: 'Dropbox',
  },
  [videoSources.GOOGLE_DRIVE]: {
    id: 'shared.video-sources.google-drive',
    defaultMessage: 'Google Drive',
  },
  [videoSources.YOUTUBE]: {
    id: 'shared.video-sources.youtube',
    defaultMessage: 'YouTube',
  },
  [videoSources.VIMEO]: {
    id: 'shared.video-sources.vimeo',
    defaultMessage: 'Vimeo',
  },
  [videoSources.FACEBOOK]: {
    id: 'shared.video-sources.facebook',
    defaultMessage: 'Facebook',
  },
  [videoSources.LIVE]: {
    id: 'shared.video-sources.live',
    defaultMessage: 'Schedule Live',
  },
  [genres.ACTION]: {
    id: 'shared.genres.action',
    defaultMessage: 'Action',
  },
  [genres.ADVENTURE]: {
    id: 'shared.genres.adventure',
    defaultMessage: 'Adventure',
  },
  [genres.ANIMATION]: {
    id: 'shared.genres.animation',
    defaultMessage: 'Animation',
  },
  [genres.AFRICAN]: {
    id: 'shared.genres.african',
    defaultMessage: 'African',
  },
  [genres.AFRICAN_AMERICAN]: {
    id: 'shared.genres.african-american',
    defaultMessage: 'African American',
  },
  [genres.ASIAN]: {
    id: 'shared.genres.asian',
    defaultMessage: 'Asian',
  },
  [genres.ASIAN_AMERICAN]: {
    id: 'shared.genres.asian-american',
    defaultMessage: 'Asian American',
  },
  [genres.BLACK]: {
    id: 'shared.genres.black',
    defaultMessage: 'Black',
  },
  [genres.BUDDHIST]: {
    id: 'shared.genres.buddhist',
    defaultMessage: 'Buddhist',
  },
  [genres.BIOGRAPHY]: {
    id: 'shared.genres.biography',
    defaultMessage: 'Biography',
  },
  [genres.CHILDREN]: {
    id: 'shared.genres.children',
    defaultMessage: 'Children',
  },
  [genres.CHRISTIAN]: {
    id: 'shared.genres.christian',
    defaultMessage: 'Christian',
  },
  [genres.COMEDY]: {
    id: 'shared.genres.comedy',
    defaultMessage: 'Comedy',
  },
  [genres.CRIME]: {
    id: 'shared.genres.crime',
    defaultMessage: 'Crime',
  },
  [genres.DIY]: {
    id: 'shared.genres.diy',
    defaultMessage: 'DIY',
  },
  [genres.DEVELOPING_NATIONS]: {
    id: 'shared.genres.developing-nations',
    defaultMessage: 'Developing Nations',
  },
  [genres.DISABILITY_CULTURE]: {
    id: 'shared.genres.disability-culture',
    defaultMessage: 'Disability Culture',
  },
  [genres.DOCUMENTARY]: {
    id: 'shared.genres.documentary',
    defaultMessage: 'Documentary',
  },
  [genres.DRAMA]: {
    id: 'shared.genres.drama',
    defaultMessage: 'Drama',
  },
  [genres.EDUCATION]: {
    id: 'shared.genres.education',
    defaultMessage: 'Education',
  },
  [genres.FAMILY]: {
    id: 'shared.genres.family',
    defaultMessage: 'Family',
  },
  [genres.FANTASY]: {
    id: 'shared.genres.fantasy',
    defaultMessage: 'Fantasy',
  },
  [genres.FILM_NOIR]: {
    id: 'shared.genres.film-noir',
    defaultMessage: 'Film-Noir',
  },
  [genres.GAME_SHOW]: {
    id: 'shared.genres.game-show',
    defaultMessage: 'Game-Show',
  },
  [genres.HISPANIC]: {
    id: 'shared.genres.hispanic',
    defaultMessage: 'Hispanic',
  },
  [genres.HISTORY]: {
    id: 'shared.genres.history',
    defaultMessage: 'History',
  },
  [genres.HORROR]: {
    id: 'shared.genres.horror',
    defaultMessage: 'Horror',
  },
  [genres.INSTRUCTIONAL]: {
    id: 'shared.genres.instructional',
    defaultMessage: 'Instructional',
  },
  [genres.ISLAMIC]: {
    id: 'shared.genres.islamic',
    defaultMessage: 'Islamic',
  },
  [genres.JEWISH]: {
    id: 'shared.genres.jewish',
    defaultMessage: 'Jewish',
  },
  [genres.LGBTQ]: {
    id: 'shared.genres.lgbtq',
    defaultMessage: 'LGBTQ',
  },
  [genres.LATINO]: {
    id: 'shared.genres.latino',
    defaultMessage: 'Latino',
  },
  [genres.MATURE_ADULT]: {
    id: 'shared.genres.mature-adult',
    defaultMessage: 'Mature/Adult',
  },
  [genres.MUSIC]: {
    id: 'shared.genres.music',
    defaultMessage: 'Music',
  },
  [genres.MUSICAL]: {
    id: 'shared.genres.musical',
    defaultMessage: 'Musical',
  },
  [genres.MYSTERY]: {
    id: 'shared.genres.mystery',
    defaultMessage: 'Mystery',
  },
  [genres.NEWS]: {
    id: 'shared.genres.news',
    defaultMessage: 'News',
  },
  [genres.NATIVE_AMERICAN]: {
    id: 'shared.genres.native-american',
    defaultMessage: 'Native American',
  },
  [genres.NATIVE_ABORIGINAL_PEOPLE]: {
    id: 'shared.genres.native-aboriginal-people',
    defaultMessage: 'Native/Aboriginal People',
  },
  [genres.PERSONAL]: {
    id: 'shared.genres.personal',
    defaultMessage: 'Personal',
  },
  [genres.REALITY_TV]: {
    id: 'shared.genres.reality-tv',
    defaultMessage: 'Reality-TV',
  },
  [genres.ROMANCE]: {
    id: 'shared.genres.romance',
    defaultMessage: 'Romance',
  },
  [genres.SCI_FI]: {
    id: 'shared.genres.sci-fi',
    defaultMessage: 'Sci-Fi',
  },
  [genres.SENIOR_AGING]: {
    id: 'shared.genres.senior-aging',
    defaultMessage: 'Senior/Aging',
  },
  [genres.SPORT]: {
    id: 'shared.genres.sport',
    defaultMessage: 'Sport',
  },
  [genres.STUDENT]: {
    id: 'shared.genres.student',
    defaultMessage: 'Student',
  },
  [genres.TALK_SHOW]: {
    id: 'shared.genres.talk-show',
    defaultMessage: 'Talk-Show',
  },
  [genres.THRILLER]: {
    id: 'shared.genres.thriller',
    defaultMessage: 'Thriller',
  },
  [genres.WAR]: {
    id: 'shared.genres.war',
    defaultMessage: 'War',
  },
  [genres.WESTERN]: {
    id: 'shared.genres.western',
    defaultMessage: 'Western',
  },
  [genres.WOMEN]: {
    id: 'shared.genres.women',
    defaultMessage: 'Women',
  },
  [genres.YOUTH_TEEN]: {
    id: 'shared.genres.youth-teen',
    defaultMessage: 'Youth/Teen',
  },
  live: {
    id: 'shared.live',
    defaultMessage: 'Live',
  },
  [roles.DIRECTOR]: {
    id: 'shared.crew.director',
    defaultMessage: 'Director',
  },
  [roles.CO_DIRECTOR]: {
    id: 'shared.crew.co-director',
    defaultMessage: 'Co-Director',
  },
  [roles.PRODUCER]: {
    id: 'shared.crew.producer',
    defaultMessage: 'Producer',
  },
  [roles.EXECUTIVE_PRODUCER]: {
    id: 'shared.crew.executive-producer',
    defaultMessage: 'Executive Producer',
  },
  [roles.CO_PRODUCER]: {
    id: 'shared.crew.co-producer',
    defaultMessage: 'Co-Producer',
  },
  [roles.ASSOCIATE_PRODUCER]: {
    id: 'shared.crew.associate-producer',
    defaultMessage: 'Associate Producer',
  },
  [roles.COLLABORATING_DIRECTOR]: {
    id: 'shared.crew.collaborating-director',
    defaultMessage: 'Collaborating Director',
  },
  [roles.PRODUCTION_MANAGER]: {
    id: 'shared.crew.production-manager',
    defaultMessage: 'Production Manager',
  },
  [roles.PRODUCTION_COORDINATOR]: {
    id: 'shared.crew.production-coordinator',
    defaultMessage: 'Production Coordinator',
  },
  [roles.PRODUCTION_ASSISTANT]: {
    id: 'shared.crew.production-assistant',
    defaultMessage: 'Production Assistant',
  },
  [roles.ASSISTANT_DIRECTOR]: {
    id: 'shared.crew.assistant-director',
    defaultMessage: 'Assistant Director',
  },
  [roles['2ND_ASSISTANT_DIRECTOR']]: {
    id: 'shared.crew.2nd-assistant-director',
    defaultMessage: '2nd Assistant Director',
  },
  [roles.SCRIPT_SUPERVISOR]: {
    id: 'shared.crew.script-supervisor',
    defaultMessage: 'Script Supervisor',
  },
  [roles.LOCATION_MANAGER]: {
    id: 'shared.crew.location-manager',
    defaultMessage: 'Location Manager',
  },
  [roles.WRITER]: {
    id: 'shared.crew.writer',
    defaultMessage: 'Writer',
  },
  [roles.CO_WRITER]: {
    id: 'shared.crew.co-writer',
    defaultMessage: 'Co-Writer',
  },
  [roles.STORY]: {
    id: 'shared.crew.story',
    defaultMessage: 'Story',
  },
  [roles.ADAPTATION]: {
    id: 'shared.crew.adaptation',
    defaultMessage: 'Adaptation',
  },
  [roles.AUTHOR_OF_ADAPTED_MATERIAL]: {
    id: 'shared.crew.author-of-adapted-material',
    defaultMessage: 'Author of Adapted Material',
  },
  [roles.CINEMATOGRAPHER_DP]: {
    id: 'shared.crew.cinematographer-dp',
    defaultMessage: 'Cinematographer/DP',
  },
  [roles.ASSISTANT_CAMERA]: {
    id: 'shared.crew.assistant-camera',
    defaultMessage: 'Assistant Camera',
  },
  [roles.ADDITIONAL_PHOTOGRAPHY]: {
    id: 'shared.crew.additional-photography',
    defaultMessage: 'Additional Photography',
  },
  [roles['2ND_UNIT_DIR_OF_PHOTOGRAPHY']]: {
    id: 'shared.crew.2nd-unit-dir-of-photography',
    defaultMessage: '2nd Unit Dir of Photography',
  },
  [roles.CAMERA_OPERATOR]: {
    id: 'shared.crew.camera-operator',
    defaultMessage: 'Camera Operator',
  },
  [roles.GAFFER]: {
    id: 'shared.crew.gaffer',
    defaultMessage: 'Gaffer',
  },
  [roles.BEST_BOY]: {
    id: 'shared.crew.best-boy',
    defaultMessage: 'Best Boy',
  },
  [roles.KEY_GRIP]: {
    id: 'shared.crew.key-grip',
    defaultMessage: 'Key Grip',
  },
  [roles.ADDITIONAL_GRIP]: {
    id: 'shared.crew.additional-grip',
    defaultMessage: 'Additional Grip',
  },
  [roles.DOLLY_GRIP]: {
    id: 'shared.crew.dolly-grip',
    defaultMessage: 'Dolly Grip',
  },
  [roles.GRIP]: {
    id: 'shared.crew.grip',
    defaultMessage: 'Grip',
  },
  [roles.SOUND_MIXER]: {
    id: 'shared.crew.sound-mixer',
    defaultMessage: 'Sound Mixer',
  },
  [roles.BOOM_OPERATOR]: {
    id: 'shared.crew.boom-operator',
    defaultMessage: 'Boom Operator',
  },
  [roles.CABLE_PERSON]: {
    id: 'shared.crew.cable-person',
    defaultMessage: 'Cable Person',
  },
  [roles.VIDEO_OPERATOR]: {
    id: 'shared.crew.video-operator',
    defaultMessage: 'Video Operator',
  },
  [roles.ART_DIRECTOR]: {
    id: 'shared.crew.art-director',
    defaultMessage: 'Art Director',
  },
  [roles.ASSISTANT_ART_DIRECTOR]: {
    id: 'shared.crew.assistant-art-director',
    defaultMessage: 'Assistant Art Director',
  },
  [roles.COSTUME_DESIGNER]: {
    id: 'shared.crew.costume-designer',
    defaultMessage: 'Costume Designer',
  },
  [roles.COSTUMER]: {
    id: 'shared.crew.costumer',
    defaultMessage: 'Costumer',
  },
  [roles.HAIRSTYLIST]: {
    id: 'shared.crew.hairstylist',
    defaultMessage: 'Hairstylist',
  },
  [roles.LEAD_PERSON]: {
    id: 'shared.crew.lead-person',
    defaultMessage: 'Lead Person',
  },
  [roles.MAKEUP_ARTIST]: {
    id: 'shared.crew.makeup-artist',
    defaultMessage: 'Makeup Artist',
  },
  [roles.MAKEUP_EFFECTS]: {
    id: 'shared.crew.makeup-effects',
    defaultMessage: 'Makeup Effects',
  },
  [roles.PRODUCTION_DESIGNER]: {
    id: 'shared.crew.production-designer',
    defaultMessage: 'Production Designer',
  },
  [roles.PROPERTY_MASTER]: {
    id: 'shared.crew.property-master',
    defaultMessage: 'Property Master',
  },
  [roles.SET_DECORATOR]: {
    id: 'shared.crew.set-decorator',
    defaultMessage: 'Set Decorator',
  },
  [roles.SET_DESIGNER]: {
    id: 'shared.crew.set-designer',
    defaultMessage: 'Set Designer',
  },
  [roles.SWING_GANG]: {
    id: 'shared.crew.swing-gang',
    defaultMessage: 'Swing Gang',
  },
  [roles.ANIMAL_TRAINER]: {
    id: 'shared.crew.animal-trainer',
    defaultMessage: 'Animal Trainer',
  },
  [roles.CHOREOGRAPHER]: {
    id: 'shared.crew.choreographer',
    defaultMessage: 'Choreographer',
  },
  [roles.SPECIAL_EFFECTS]: {
    id: 'shared.crew.special-effects',
    defaultMessage: 'Special Effects',
  },
  [roles.STUNT_COORDINATOR]: {
    id: 'shared.crew.stunt-coordinator',
    defaultMessage: 'Stunt Coordinator',
  },
  [roles.TECHNICAL_ADVISOR]: {
    id: 'shared.crew.technical-advisor',
    defaultMessage: 'Technical Advisor',
  },
  [roles.EDITOR]: {
    id: 'shared.crew.editor',
    defaultMessage: 'Editor',
  },
  [roles.ASSISTANT_EDITOR]: {
    id: 'shared.crew.assistant-editor',
    defaultMessage: 'Assistant Editor',
  },
  [roles.SOUND_EDITOR]: {
    id: 'shared.crew.sound-editor',
    defaultMessage: 'Sound Editor',
  },
  [roles.DIGITAL_EFFECTS]: {
    id: 'shared.crew.digital-effects',
    defaultMessage: 'Digital Effects',
  },
  [roles.ORIGINAL_MUSIC_COMPOSER]: {
    id: 'shared.crew.original-music-composer',
    defaultMessage: 'Original Music/Composer',
  },
  [roles.ANIMATOR]: {
    id: 'shared.crew.animator',
    defaultMessage: 'Animator',
  },
  [roles.AGENT]: {
    id: 'shared.crew.agent',
    defaultMessage: 'Agent',
  },
  [roles.MANAGER]: {
    id: 'shared.crew.manager',
    defaultMessage: 'Manager',
  },
  [roles.PUBLICIST]: {
    id: 'shared.crew.publicist',
    defaultMessage: 'Publicist',
  },
  [roles.PRINT_SHIPPER]: {
    id: 'shared.crew.print-shipper',
    defaultMessage: 'Print Shipper',
  },
  [roles.PRINT_RETURN]: {
    id: 'shared.crew.print-return',
    defaultMessage: 'Print Return',
  },
  [roles.PREVIEW_RETURN]: {
    id: 'shared.crew.preview-return',
    defaultMessage: 'Preview Return',
  },
  [roles.ACADEMIC_ADVISOR]: {
    id: 'shared.crew.academic-advisor',
    defaultMessage: 'Academic Advisor',
  },
  [roles.SCHOOL_ADMINISTRATOR]: {
    id: 'shared.crew.school-administrator',
    defaultMessage: 'School Administrator',
  },
  [categoryKeys.POPULAR]: {
    id: 'shared.crew-category.popular',
    defaultMessage: 'Popular',
  },
  [categoryKeys.PRODUCTION]: {
    id: 'shared.crew-category.production',
    defaultMessage: 'Production',
  },
  [categoryKeys.WRITING]: {
    id: 'shared.crew-category.writing',
    defaultMessage: 'Writing',
  },
  [categoryKeys.CAMERA]: {
    id: 'shared.crew-category.camera',
    defaultMessage: 'Camera',
  },
  [categoryKeys.ELECTRICS]: {
    id: 'shared.crew-category.electrics',
    defaultMessage: 'Electrics',
  },
  [categoryKeys.GRIP]: {
    id: 'shared.crew-category.grip',
    defaultMessage: 'Grip',
  },
  [categoryKeys.SOUND_AND_VIDEO]: {
    id: 'shared.crew-category.sound-and-video',
    defaultMessage: 'Sound and video',
  },
  [categoryKeys.ART]: {
    id: 'shared.crew-category.art',
    defaultMessage: 'Art',
  },
  [categoryKeys.SPECIALIZED]: {
    id: 'shared.crew-category.specialized',
    defaultMessage: 'Specialized',
  },
  [categoryKeys.POST_PRODUCTION]: {
    id: 'shared.crew-category.post-production',
    defaultMessage: 'Post Production',
  },
  [categoryKeys.ANIMATION]: {
    id: 'shared.crew-category.animation',
    defaultMessage: 'Animation',
  },
  [categoryKeys.REPRESENTATION]: {
    id: 'shared.crew-category.representation',
    defaultMessage: 'Representation',
  },
  [categoryKeys.PRINT_TRAFFIC]: {
    id: 'shared.crew-category.print-traffic',
    defaultMessage: 'Print Traffic',
  },
  [categoryKeys.ACADEMIC]: {
    id: 'shared.crew-category.academic',
    defaultMessage: 'Academic',
  },
  closeAllCards: {
    id: 'widget.accessibility.close-all-cards',
    defaultMessage: 'Close all cards',
  },
  scheduledSoonLabel: {
    id: 'widget.accessibility.scheduled-soon-label',
    defaultMessage: 'Live starts soon',
  },
  scheduledLabel: {
    id: 'widget.accessibility.scheduled-label',
    defaultMessage: 'Scheduled live',
  },
  startsIn: {
    id: 'widget.accessibility.starts-in',
    defaultMessage: 'Starts in',
  },
  reminder: {
    id: 'widget.accessibility.reminder',
    defaultMessage: 'Add to google calendar',
  },
  getSubscription: {
    id: 'widget.overlay-buttons.get-subscription',
    defaultMessage: 'Subscribe {price}/mo.',
  },
  buyFrom: {
    id: 'widget.overlay-buttons.buy-from',
    defaultMessage: 'Buy from {price}',
  },
  buy: {
    id: 'widget.overlay-buttons.buy',
    defaultMessage: 'Buy {price}',
  },
  overlayRent: {
    id: 'widget.overlay-buttons.rent',
    defaultMessage: 'Rent {price}',
  },
});



// WEBPACK FOOTER //
// ./src/messages/shared.js